import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TfTooltipComponent } from "./tf-tooltip/tf-tooltip.component";
import { TfTooltip } from "./tf-tooltip/tf-tooltip.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [TfTooltip, TfTooltipComponent],

  exports: [TfTooltip, TfTooltipComponent],
})
export class TfTooltipModule {}
